import { cardAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(cardAnatomy.keys)

// const alternateStyle = definePartsStyle({
// 	container: {
// 		backgroundColor: 'gray.200',
// 		width: '752px',
// 		p: "16px",
// 		borderRadius: '8px',
// 	},
// })
const invisibleStyle = definePartsStyle({
  container: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    outline: 'none',
    border: 'none',
  },
})

const baseStyle = definePartsStyle({
  container: {
    backgroundColor: 'background.White',
    w: '800px',
    p: '16px',
    borderRadius: '16px',
    boxShadow:
      '0px 1px 2px rgba(93, 94, 203, 0.04), 0px 2px 8px rgba(93, 94, 203, 0.06)',
  },
})

const repost = definePartsStyle({
  container: {
    backgroundColor: 'background.White',
    w: '100%',
    h: '40px',
    py: '8px',
    px: '12px',
    borderTopRadius: '8px',
    borderBottomRadius: '0px',
  },
})

// const test = definePartsStyle({
// 	container: {
// 	  backgroundColor: 'orange',
// 	  width: '752px',
// 	  p: "16px",
// 	  borderRadius: '8px',
// 	}

// })

const variants = {
  invisibleStyle: invisibleStyle,
  repost: repost,
}

export const CardProps = defineMultiStyleConfig({ baseStyle, variants })
